import {
    put,
    call,
    takeEvery,
    all
  } from 'redux-saga/effects';
import api from '../../client/utils/clientApiHelper' 
import { globalLoaderText } from "redux/CommonDashboard/actions";

import * as ManagedEquipmentActions from './action';

import {
    GET_MANAGED_EQUIPMENT_ITEM_DETAILS
} from './types'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getManagedEquipmentItemDetailsSaga(req:any):any {
    try { 
      yield put(globalLoaderText("Fetching Equipments..."));
      yield put(ManagedEquipmentActions.setManagedEquipmentItemDetails([], "noRecordsMessage", req?.fleetRequestDetailId ?? null));
      let catlogRequestBody=req.catalogRequestBody;
      let payloadData : IPayload= {
        apiType : apiType.AssetManagement,
        endpoint : `assets/managedequipment/catalogitems`,
        apiMethod : apiMethod.POST,
        payload : catlogRequestBody
      }
      

     
      const response=yield call(api.callAssetPost,API_URL.PostWebApp, payloadData);
       response.forEach((element:any) => {
        element['isSelected']=false;
      });
        yield put(ManagedEquipmentActions.setManagedEquipmentItemDetails(response, '', req?.fleetRequestDetailId ?? null));
        yield put(globalLoaderText(""));
   
    } catch (error) {
        const noRecordsMessage='No Records to display'
        yield put(ManagedEquipmentActions.setManagedEquipmentItemDetails([], noRecordsMessage, req?.fleetRequestDetailId ?? null));
        yield put(globalLoaderText(""));
    }
}

function* watchGetUserProfileSaga() {
    yield takeEvery(GET_MANAGED_EQUIPMENT_ITEM_DETAILS, getManagedEquipmentItemDetailsSaga);
}

export default function* combinedSaga() {
    yield all([
        watchGetUserProfileSaga()
    ])
}